var exports = {
  "kL": "AudioPlayer.module__container___amo5NV",
  "Md": "AudioPlayer.module__fileName___amo5NV",
  "NE": "AudioPlayer.module__progressSection___amo5NV",
  "hr": "AudioPlayer.module__progressBar___amo5NV",
  "Ey": "AudioPlayer.module__timeDisplay___amo5NV",
  "ne": "AudioPlayer.module__controls___amo5NV",
  "gm": "AudioPlayer.module__mainControls___amo5NV",
  "Rr": "AudioPlayer.module__playButton___amo5NV",
  "$3": "AudioPlayer.module__seekButton___amo5NV",
  "f6": "AudioPlayer.module__secondaryControls___amo5NV",
  "Wq": "AudioPlayer.module__volumeControl___amo5NV",
  "Sn": "AudioPlayer.module__playbackRate___amo5NV",
  "Hw": "AudioPlayer.module__mobile___amo5NV",
};

module.exports = exports;
